import type { SubscriptionPlan } from '../../types/subscription';
import type { TrialInput } from '../../types/billing';

export interface TrialDraft {
  days: number;
  seats: Record<string, number>;
}

export const TRIAL_DAY_OPTIONS = [14, 30, 60, 90];

export function newTrialDraft(plan: SubscriptionPlan, days = 30): TrialDraft {
  const seats: Record<string, number> = {};
  for (const lt of plan.license_types ?? []) seats[lt.type_key] = 0;
  const first = plan.license_types?.[0];
  if (first) seats[first.type_key] = 1;
  return { days, seats };
}

export function draftsToTrials(drafts: Record<number, TrialDraft>, reason?: string): TrialInput[] {
  return Object.entries(drafts).map(([planId, d]) => ({
    plan_id: Number(planId),
    days: d.days,
    seats: Object.entries(d.seats).filter(([, n]) => n > 0).map(([type_key, total_seats]) => ({ type_key, total_seats })),
    reason,
  }));
}

